import { Button } from '@/components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const OptionsContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const OptionButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '38px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&:disabled': {
    cursor: 'not-allowed',
    borderColor: theme.palette.action.disabled,
  },

  [theme.breakpoints.down('md')]: {
    fontSize: '14px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    minWidth: 0,
  },
}));

export const TitleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: theme.spacing(1),
}));
